import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  submitCompleteProfile,
  submitUpdateProfile,
} from "../../Actions/userActions";
import { Box, Button, div, Typography } from "@mui/material";
import "./InterestGrid.css";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";

const Interestdivs = ({
  userData,
  setShowInterestCollectionGrid,
  currentUser,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedCategories, setSelectedCategories] = useState([]);
  const addTo = (e, value) => {
    e.preventDefault();
    console.log("c in addTo", value);

    let array = selectedCategories;
    let res = array.includes(value);
    console.log("res", res);
    if (res) {
      array = array?.filter((a) => a !== value);
      setSelectedCategories(array);
    } else {
      //   array.push(value);
      if (selectedCategories?.length > 4) {
        return;
      }
      setSelectedCategories([...array, value]);
    }

    // console.log("selected category", array);
  };

  const submit = (e) => {
    e.preventDefault();
    // let data = (userData = {
    //   userId: userData.userId,
    //   name: userData?.name,
    //   userRole: userData?.userRole,
    //   gender: userData?.gender,
    //   userIdentityFile: userData?.userIdentityFile,
    //   phone: userData?.phone,
    //   address: userData?.address,
    //   categoriesInterested: selectedCategories,
    // });
    console.log("selected categories", selectedCategories);
    localStorage.setItem(
      "currentUser",
      JSON.stringify({
        ...currentUser,
        categoriesInterested: selectedCategories,
      })
    );
    setTimeout(() => {
      setShowInterestCollectionGrid(false);
      // window.location.reload();
    }, 1000);
    api
      .post(
        "/auth/update-categories-interested/" + currentUser?.id,
        selectedCategories
      )
      .then((res) => {
        // localStorage.setItem(
        //   "currentUser",
        //   JSON.stringify({
        //     ...currentUser,
        //     categoriesInterested: res.data?.categoriesInterested,
        //   })
        // );
        setTimeout(() => {
          setShowInterestCollectionGrid(false);
          window.location.reload();
        }, 1000);

        console.log("response", res?.data);
      })
      .catch((err) => console.log(err));

    //  dispatch(submitCompleteProfile(data, navigate));
    // console.log("data", data);
  };

  const categories = [
    "hostels",
    "internships",
    "scholarships",
    "projects",
    "fyps",
    "development",
    "technology",
    "design",
    "courses",
    "digitalMarketing",
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",

        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "70%",
          height: "80%",
          backgroundColor: "colorWhite.main",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          overflowY: "scroll",
          padding: "20px 0",
        }}
      >
        <Box sx={{ flex: 0.8 }} className="grid__wrapper">
          <Typography variant="h5" sx={{ margin: "20px 0" }}>
            Tell us what you are interested in
          </Typography>
          <div className="grid__container">
            {categories?.map((c) => (
              <div
                className={selectedCategories?.includes(c) ? "active" : "ot"}
                onClick={(e) => addTo(e, c)}
              >
                <Typography
                  variant="p"
                  sx={{ color: "#fff", textTransform: "capitalize" }}
                >
                  {c}
                </Typography>
              </div>
            ))}
          </div>
        </Box>
        <Box sx={{ flex: 0.2 }}>
          <button
            className="asc__submit__form__button"
            onClick={(e) => submit(e)}
          >
            Continue
          </button>
        </Box>
      </Box>
    </Box>
  );
};

export default Interestdivs;
